module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 80.68f84b19.png";